import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getReasons } from "../navigoSlice";
import { useSelector } from "react-redux";
import BackButton from "../../../components/common/BackButton";
import { IonGrid, IonRow, IonCol, IonPage, IonContent } from "@ionic/react";
import CameraImage from "../../../assets/images/camera2.png";
import DocumentImage from "../../../assets/images/documents.png";
import ImageIconImage from "../../../assets/images/images.png";
import { Dialog, DialogContent } from "@mui/material";
import { useRef } from "react";
import { useLocation, useHistory } from "react-router";
import { createAppointments } from "../navigoSlice";
import { NavContext } from "@ionic/react";
import { useContext } from "react";
import { logEvent } from "../../../app/eventSlice";
import navigoServices from "../../../services/NavigoServices";
import { setStateFromPayload } from "../navigoSlice";
import { errorMessageHandler } from "../utilityFunctions";
import { navigoShowError } from "../navigoSlice";
import indiaFlag from "../../../assets/images/flag_india.png";
import moment from "moment";
import documentService from "../../../services/DocumentService";
import useUnhidePageOnEnter from "../../../hooks/useUnhidePageOnEnter";
import { withFrom } from "../utils/navBack";
function ReasonScreen() {
  // Ionic can leave this page `ion-page-hidden` on re-entry, blanking it.
  const pageRef = useUnhidePageOnEnter();
  const location = useLocation();
  const history = useHistory();
  const navContext = useContext(NavContext);
  const body = location?.state?.body;
  const services = location?.state?.services;
  const price = location?.state?.price;
  const pageType = location?.state?.pageType;
  // Second Medical Opinion reordered flow: this screen is reached BEFORE
  // provider/slot selection and only collects reason + files (it does not book).
  const smoCollectOnly = location?.state?.smoCollectOnly;
  //   const service
  const dispatch = useDispatch();
  const navigoStore = useSelector((store) => store.navigo);
  const [isEditing, setIsEditing] = useState(false);
  const [reason, setReason] = useState("");
  const { reasons } = navigoStore;
  const [reasonId, setReasonId] = useState();
  const [reasonDetails, setReasonDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fileNote, setFileNote] = useState("");
  const [uploadDocument, setUploadDocument] = useState(false);
  const [clickUpload, setClickUpload] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [fileType, setFileType] = useState("image/*");
  const [fileUpload, setFileUpload] = useState(false);
  const [isCustomContactNumber, setIsCustomContactNumber] = useState(false);
  const [customContactNumber, setCustomContactNumber] = useState(null);
  const [prescriptionFiles, setPrescriptionFiles] = useState([]);
  const [labReportFiles, setLabReportFiles] = useState([]);
  const [activeUploadCategory, setActiveUploadCategory] = useState(null);

  const inputFileRef = useRef(null);
  const patientProfile = useSelector(
    (store) => store.login.user.patientProfile,
  );
  const [phone, setPhone] = useState(patientProfile.phoneno || "");

  useEffect(() => {
    if (pageType === 8 && reasons.length > 0) {
      const reason7 = reasons.find((r) => r.id === 7);
      if (reason7) {
        setReasonId(7);
        setReason(reason7.name);
        setUploadDocument(true);
      }
    }
  }, [pageType, reasons]);

  const onChooseFileType = (type) => {
    if (!inputFileRef.current) return;

    setFileType(type === "I" ? "image/*" : "application/pdf");
    setClickUpload(false);

    setTimeout(() => {
      inputFileRef.current.click();
    }, 100);
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const handleCategoryAdd = (category) => {
    if (category === 'prescription' && prescriptionFiles.length >= 8) return;
    if (category === 'labReport' && labReportFiles.length >= 8) return;
    setActiveUploadCategory(category);
    setClickUpload(true);
  };

  const handleRemoveFile = (category, index) => {
    if (category === 'prescription') {
      setPrescriptionFiles(prev => prev.filter((_, i) => i !== index));
    } else {
      setLabReportFiles(prev => prev.filter((_, i) => i !== index));
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newFiles = files.map((file) => ({
      file,
      previewUrl: URL.createObjectURL(file),
      note: "",
    }));

    if (reasonId === 7 && activeUploadCategory) {
      const filtered = newFiles.filter(f => f.file.size <= 5 * 1024 * 1024);
      if (activeUploadCategory === 'prescription') {
        const limited = [...prescriptionFiles, ...filtered].slice(0, 8);
        setPrescriptionFiles(limited);
      } else if (activeUploadCategory === 'labReport') {
        const limited = [...labReportFiles, ...filtered].slice(0, 8);
        setLabReportFiles(limited);
      }
      setActiveUploadCategory(null);
    } else {
      const limitedFiles = [...uploadedFiles, ...newFiles].slice(0, 8);
      setUploadedFiles(limitedFiles);

      if (limitedFiles.length > 0) {
        setUploadedFile(true);
      }
    }
  };

  //   const handleCreateAppointment = () => {
  //     let body = {
  //       patientID: patientProfile.id,
  //       bookedFor:
  //         familyMemberSelected === -1
  //           ? 0
  //           : familyMemberSelectedData.memberPatientId,
  //       serviceID: services.ID,
  //       status: 0,
  //       bookingDate: new Date().toISOString(),
  //       appointmentDate: new Date(
  //         moment(appointmentDate).add(1, "h").format()
  //       ).toISOString(),
  //       timeSlot: stringToIntTime(timeSlot.time),
  //       timeSlotId: timeSlot.id,
  //       vendorId: vendorId,
  //     };

  //     if (currentServices.addressRequired) {
  //       body.addressId = addressSelected.id;
  //     }

  //     if (
  //       currentServices.discountedPrice !== 0 &&
  //       currentServices.discountedPrice !== null
  //     ) {
  //       dispatch(logEvent({ action: `click payment` }));
  //       body.orderId = "";
  //       startPayment(body);
  //       return;
  //     }
  //     dispatch(createAppointments(body))
  //       .unwrap()
  //       .then((res) => {
  //         dispatch(
  //           setStateFromPayload({
  //             currScreen: 1,
  //             addressSelected: null,
  //             loadedAppointments: false,
  //             fetchingAppointments: false,
  //             openDrawer: false,
  //             openZylaPay: false,
  //             openBookAfterPayment: false,
  //           })
  //         );
  //         dispatch(logEvent({ action: `Confirm appointment` }));
  //         navContext.navigate(
  //           `/mliNavigo/bookingCard?date=${moment(appointmentDate).format(
  //             "DD MMM, YYYY"
  //           )}&time=${timeSlot.time}`,
  //           "none",
  //           "pop"
  //         );
  //       })
  //       .catch((err) => {});
  //   };
  const handleCreateAppointment = async () => {
    // SMO reordered flow: don't book here. Stash the collected reason/files in
    // redux and move on to provider selection; the final slot step will book.
    if (smoCollectOnly) {
      dispatch(
        setStateFromPayload({
          smoDraft: {
            reasonId: reasonId || 7,
            reasonDetails: reasonDetails || "",
            isCustomContactNumber,
            customContactNumber,
            prescriptionFiles,
            labReportFiles,
          },
        }),
      );
      history.push({
        pathname: "/providerCard",
        state: withFrom(location, { service: services, pageType: 8 }),
      });
      return;
    }

    const source = localStorage.getItem("app_source") === "pb" ? "pb" : "mli";
    const finalBody = {
      ...(body || {}),
      reasonId: reasonId || 1,
      reasonDetails: reasonDetails || "",
      isCustomContactNumber: isCustomContactNumber,
      customContactNumber: customContactNumber,
      metadata: { source: source },
    };
    const appointmentDate = finalBody.appointmentDate;
    const timeSlot = finalBody.timeSlot;

    if (price !== 0) {
      dispatch(logEvent({ action: `click payment` }));
      finalBody.orderId = "";
      // Paid: don't upload yet. Stash the collected files so BookAfterPayment
      // uploads + maps them AFTER the v1 zpay status comes back successful
      // (same upload + file-selection logic as the free path below).
      const filesToUpload =
        reasonId === 7
          ? [
              ...prescriptionFiles.map((f) => ({
                ...f,
                category: "prescription",
              })),
              ...labReportFiles,
            ]
          : uploadedFiles;
      if (filesToUpload && filesToUpload.length > 0) {
        dispatch(
          setStateFromPayload({
            pendingPaidDocs: {
              files: filesToUpload,
              patientId: patientProfile.id,
            },
          }),
        );
      }
      startPayment(finalBody);
      return;
    }

    setIsLoading(true);
    dispatch(createAppointments(finalBody))
      .unwrap()
      .then(async (res) => {
        const appointmentId = res?.data?.id;
        dispatch(logEvent({ action: `Confirm appointment` }));

        const filesToUpload = reasonId === 7
          ? [
              ...prescriptionFiles.map(f => ({ ...f, category: 'prescription' })),
              ...labReportFiles,
            ]
          : uploadedFiles;

        if (filesToUpload && filesToUpload.length > 0 && appointmentId) {
          console.log("Uploading documents");
          const documentIds = await uploadDocuments(
            filesToUpload,
            patientProfile.id,
          );

          console.log("Mapping documents to appointment", documentIds);
          await Promise.all(
            documentIds.map((id) => {
              console.log("inside mapping", id, appointmentId);
              return documentService.documentMapping(appointmentId, id);
            }),
          );
        }

        navContext.navigate(
          `/mliNavigo/bookingCard?date=${moment(appointmentDate).format(
            "DD MMM, YYYY",
          )}&time=${timeSlot.time}`,
          "none",
          "pop",
        );
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error booking appointment:", err);
        setIsLoading(false);
      });
  };

  const uploadDocuments = async (files, patientId) => {
    const uploadedDocumentIds = [];

    for (const item of files) {
      const actualFile = item.file;

      if (actualFile.size <= 20000000) {
        const document = {
          patientId: patientId,
          title: actualFile.name,
          description: "",
          format: 2,
          type: item.category === 'prescription' ? 9 : 11,
          status: 4,
        };

        try {
          const response = await documentService.uploadDocument(
            actualFile,
            actualFile.name,
            document,
            null,
            patientId,
          );

          const documentId = response?.data?.id;
          if (documentId) {
            uploadedDocumentIds.push(documentId);
          }
        } catch (error) {
          console.error("Document upload failed for:", actualFile.name, error);
        }
      } else {
        console.log("File size exceeds 20MB:", actualFile.name);
      }
    }

    return uploadedDocumentIds;
  };

  const startPayment = (body) => {
    try {
      navigoServices
        .generateOrderForNavigo(body)
        .then((result) => {
          const res = result.data;

          if (window.Capacitor.platform !== "web") {
            setTimeout(() => {
              let url = `${process.env.REACT_APP_ZYLA_PAY_URL}?orderId=${res.orderId}&redirect=https://ep3z4.app.goo.gl/oi43`;
              window.open(url, "_top");
            });
          }

          dispatch(
            setStateFromPayload({
              openZylaPay: true,
              paymentLoaderOrderId: res.orderId,
            }),
          );
        })
        .catch((err) => {
          let errMsg = "Couldn't create appointment.";

          if (err && err.message) {
            errMsg = errorMessageHandler(
              err?.response?.data,
              "Couldn't create appointment.",
            );
          }
          dispatch(navigoShowError({ msg: errMsg }));
        });
    } catch (err) {
      dispatch(navigoShowError({ msg: "Something went wrong." }));
    }
  };
  const handleSkip = () => {
    handleCreateAppointment();
  };

  const handleUploadLabReport = () => {
    setClickUpload(true);
  };

  const handleAddMoreDocuments = () => {
    setClickUpload(true);
  };

  const handleBookNow = () => {
    handleCreateAppointment();
  };

  return (
    <IonPage ref={pageRef}>
      <IonContent>
        {isLoading && (
          <div className="fixed inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center z-50">
            <div className="w-10 h-10 mb-4 border-4 border-t-4 border-[#97144D] border-t-transparent rounded-full animate-spin"></div>
            <p className="text-[#97144D] font-medium text-lg">
              Creating your appointment...
            </p>
          </div>
        )}{" "}
        <div className="p-4 pb-48 font-sans mx-auto">
          <BackButton />

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-1000 mb-1">
              Contact number<span className="text-red-500">*</span>
            </label>
            <div className="p-4 bg-white shadow-md rounded-lg border border-gray-400 w-full max-w-md mx-auto">
              <div className="flex items-center">
                <img
                  src={indiaFlag}
                  style={{ width: "24px" }}
                  alt="India Flag"
                  className="w-5 h-5 inline-block mr-2"
                />
                <span className="text-base">
                  +{patientProfile.countryCode}-
                </span>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => {
                    const enteredPhone = e.target.value;
                    setPhone(enteredPhone);

                    if (enteredPhone !== patientProfile.phoneNo) {
                      setIsCustomContactNumber(true);
                      setCustomContactNumber({
                        countryCode: 91,
                        phoneNo: parseInt(enteredPhone),
                      });
                    } else {
                      setIsCustomContactNumber(false);
                      setCustomContactNumber(null);
                    }
                  }}
                  className="flex-grow text-base border-none outline-none"
                  maxLength={10}
                  pattern="[0-9]*"
                  placeholder="Enter phone number"
                />
              </div>
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-1000 mb-1">
              Reason for consultation<span className="text-red-500">*</span>
            </label>
            <select
              value={reason}
              onChange={(e) => {
                const selectedReason = reasons.find(
                  (r) => r.name === e.target.value,
                );
                setReasonId(selectedReason?.id);
                setReason(selectedReason?.name || "");
                setUploadDocument(selectedReason?.id === 3 || selectedReason?.id === 7);
              }}
              className="w-full border px-4 py-3 rounded text-gray-600 text-base"
              disabled={pageType === 8 || uploadedFile || (prescriptionFiles.length + labReportFiles.length > 0)}
            >
              <option value="" disabled>
                Reason for consultation*
              </option>
              {reasons.map((r) => (
                <option key={r.id} value={r.name}>
                  {r.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <p className="font-semibold text-base mb-1">
              Please describe the reason
            </p>
            <textarea
              value={reasonDetails}
              onChange={(e) => setReasonDetails(e.target.value)}
              placeholder="Type out your answer"
              maxLength={250}
              rows={4}
              className="w-full border px-4 py-3 rounded resize-none text-base"
            />
            <div className="text-right text-sm text-gray-400">
              {reasonDetails.length}/250
            </div>
          </div>

          {reasonId === 7 && uploadDocument && (
            <div className="mb-28">
              {/* Upload prescription section */}
              <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-lg font-bold text-gray-900">Upload prescription</h3>
                  <button
                    onClick={() => handleCategoryAdd('prescription')}
                    disabled={prescriptionFiles.length >= 8}
                    className="px-3 py-1 bg-[#97144D] text-white rounded font-semibold text-sm disabled:opacity-50"
                  >
                    + Add
                  </button>
                </div>

                {prescriptionFiles.length === 0 ? (
                  <div
                    onClick={() => handleCategoryAdd('prescription')}
                    className="border-2 border-dashed border-gray-300 rounded-lg p-5 flex items-center gap-4 cursor-pointer hover:border-gray-400"
                  >
                    <div className="w-12 h-12 bg-[#97144D] rounded-lg flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5-5m0 0l5 5m-5-5v12" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">Prescription</p>
                      <p className="text-sm text-gray-500">PDF, JPG - up to 5 MB (max. 8 files)</p>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    {prescriptionFiles.map((item, index) => (
                      <div key={index} className="border border-gray-200 rounded-lg p-4 flex items-center gap-4">
                        <div className="w-12 h-12 bg-[#97144D] rounded-lg flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5-5m0 0l5 5m-5-5v12" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-semibold text-gray-800">Prescription</p>
                          <p className="text-sm text-gray-500 truncate">{item.file.name} · {formatFileSize(item.file.size)}</p>
                        </div>
                        <button
                          onClick={() => handleRemoveFile('prescription', index)}
                          aria-label="Remove file"
                          className="flex items-center justify-center w-7 h-7 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Upload lab reports section */}
              <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-lg font-bold text-gray-900">Upload lab reports</h3>
                  <button
                    onClick={() => handleCategoryAdd('labReport')}
                    disabled={labReportFiles.length >= 8}
                    className="px-3 py-1 bg-[#97144D] text-white rounded font-semibold text-sm disabled:opacity-50"
                  >
                    + Add
                  </button>
                </div>

                {labReportFiles.length === 0 ? (
                  <div
                    onClick={() => handleCategoryAdd('labReport')}
                    className="border-2 border-dashed border-gray-300 rounded-lg p-5 flex items-center gap-4 cursor-pointer hover:border-gray-400"
                  >
                    <div className="w-12 h-12 bg-[#97144D] rounded-lg flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">Lab report</p>
                      <p className="text-sm text-gray-500">PDF, JPG - up to 5 MB (max. 8 files)</p>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    {labReportFiles.map((item, index) => (
                      <div key={index} className="border border-gray-200 rounded-lg p-4 flex items-center gap-4">
                        <div className="w-12 h-12 bg-[#97144D] rounded-lg flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-semibold text-gray-800">Lab report</p>
                          <p className="text-sm text-gray-500 truncate">{item.file.name} · {formatFileSize(item.file.size)}</p>
                        </div>
                        <button
                          onClick={() => handleRemoveFile('labReport', index)}
                          aria-label="Remove file"
                          className="flex items-center justify-center w-7 h-7 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Fixed bar: it is out of flow, so the scrolling content above
              reserves room for it via pb-48 (see the wrapper below). It also
              needs its own background — without one, content scrolls visibly
              underneath it. */}
          <div className="fixed bottom-4 left-0 w-full px-4 pb-0 shadow-lg bg-white pt-3">
            {uploadDocument && reasonId === 7 ? (
              <button
                onClick={handleBookNow}
                disabled={!reason || isLoading || (prescriptionFiles.length + labReportFiles.length === 0)}
                className={`w-full py-4 text-white text-lg font-semibold rounded transition-colors ${
                  !reason || isLoading || (prescriptionFiles.length + labReportFiles.length === 0)
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#97144D] hover:bg-[#7e1041]"
                }`}
              >
                {smoCollectOnly ? "Continue" : "Book now"}
              </button>
            ) : uploadDocument ? (
              <>
                <div className="w-full text-center mb-6">
                  <button
                    onClick={uploadedFile ? handleAddMoreDocuments : handleSkip}
                    className="bg-transparent text-sm underline font-semibold"
                  >
                    {uploadedFile ? "Add more documents" : "Skip"}
                  </button>
                </div>
                <button
                  onClick={uploadedFile ? handleBookNow : handleUploadLabReport}
                  disabled={!reason || isLoading}
                  className={`w-full py-4 text-white text-lg font-semibold rounded transition-colors ${
                    !reason || isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-[#97144D] hover:bg-[#7e1041]"
                  }`}
                >
                  {uploadedFile ? "Book now" : "Upload lab report"}
                </button>
              </>
            ) : (
              <button
                onClick={handleCreateAppointment}
                disabled={!reason || isLoading}
                className={`w-full py-4 text-white text-lg font-semibold rounded transition-colors ${
                  !reason || isLoading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#97144D] hover:bg-[#7e1041]"
                }`}
              >
                Book now
              </button>
            )}
          </div>

          <input
            type="file"
            ref={inputFileRef}
            accept={fileType}
            multiple
            style={{ display: "none" }}
            onChange={handleFileChange}
          />

          {clickUpload && (
            <Dialog
              disableEnforceFocus
              open={clickUpload}
              onClose={() => setClickUpload(false)}
              aria-labelledby="form-dialog-title"
            >
              <DialogContent
                className="text-center"
                style={{ paddingTop: "20px", paddingBottom: "20px" }}
              >
                <h4 className="mt-0">
                  Select the file type you want to upload.
                </h4>
                <IonGrid>
                  <IonRow>
                    <IonCol onClick={() => onChooseFileType("I")}>
                      <img src={ImageIconImage} alt="Image" />
                      <br />
                      Image
                    </IonCol>
                    <IonCol onClick={() => onChooseFileType("P")}>
                      <img src={DocumentImage} alt="PDF" />
                      <br />
                      PDF
                    </IonCol>
                  </IonRow>
                  <p>You can upload upto 8 files here</p>
                  <h6>(Max size 20 MB)</h6>
                </IonGrid>
              </DialogContent>
            </Dialog>
          )}
          {uploadedFiles.length > 0 && (
            <div className="mt-4">
              <p className="font-semibold mb-2">Lab reports</p>

              {uploadedFiles.map(
                (item, index) => (
                  console.log(item.file.type),
                  (
                    <div key={index} className="mb-4">
                      {item.file.type.includes("image") ? (
                        <img
                          src={item.previewUrl}
                          alt={`Preview ${index}`}
                          className="max-w-full max-h-60 rounded shadow-md mb-2"
                        />
                      ) : item.file.type.includes("pdf") ? (
                        <div className="w-full h-60 border rounded mb-2 flex items-center justify-center bg-gray-100">
                          <p className="text-gray-700 font-medium text-center px-4">
                            {item.file.name}
                          </p>
                        </div>
                      ) : (
                        <p className="text-gray-500">
                          Preview not available for this file type
                        </p>
                      )}

                      <div>
                        <div
                          contentEditable
                          placeholder="Type your notes here..."
                          className="border border-gray-300 rounded p-2 min-h-[40px] outline-none focus:border-[#97144D]"
                          onInput={(e) => {
                            const updated = [...uploadedFiles];
                            updated[index].note = e.currentTarget.textContent;
                            setUploadedFiles(updated);
                          }}
                        ></div>
                      </div>
                    </div>
                  )
                ),
              )}
            </div>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
}

export default ReasonScreen;
